// extracted by mini-css-extract-plugin
export default {"directQuote":"TextSlider_directQuote__MVwx8","authorsRow":"TextSlider_authorsRow__xCmFu","authorsCol":"TextSlider_authorsCol__TCTPP","authorsText":"TextSlider_authorsText__WK0R+"};